import { buildResponsiveCSS } from '../../../utils/css.mjs';
import styled from 'styled-components';

var Variant;
(function (Variant) {
    Variant["Muted"] = "muted";
    Variant["Strong"] = "strong";
})(Variant || (Variant = {}));
const StyledLineSeparator = styled.hr `
  box-sizing: border-box;
  border: 0;
  border-top-style: solid;
  border-top-color: ${props => props.variant === Variant.Strong
    ? props.theme.colors.lineSeparatorStrongColor
    : props.theme.colors.lineSeparatorMutedColor};
  border-top-width: ${props => (props.variant === Variant.Strong ? '2px' : '1px')};
  ${props => buildResponsiveCSS('margin', props.margin ? props.margin : ['2.25rem 1rem', '2.5rem 0'])};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    border-top: 1px solid
      ${props => props.variant === Variant.Strong
    ? props.theme.colors.lineSeparatorStrongColor
    : props.theme.colors.lineSeparatorMutedColor};
  }
`;

export { StyledLineSeparator, Variant };
//# sourceMappingURL=LineSeparator.styles.mjs.map
